import React from 'react';
import { observer } from 'mobx-react';
import { Trans } from 'react-i18next';

import { Heading, Box, Paragraph } from 'components';

// import AddressCard from 'apps/addresses/blocks/AddressCard';

interface PaymentInfoProps {
  payment: any;
}

export const PaymentInfo = observer(({ payment }: PaymentInfoProps) => {
  // const { card, billingAddress } = payment;
  const { card } = payment;

  if (!card) {
    return null;
  }

  return (
    <Box
      sx={{
        justifyContent: 'space-between',
        display: 'flex',
      }}
    >
      <Box>
        <Heading level={2} size='medium'>
          <Trans>Payment Method</Trans>
        </Heading>
        <Paragraph>
          {card.brand.charAt(0).toUpperCase() + card.brand.slice(1)}
        </Paragraph>
        <Paragraph mt={2} data-testid='paymentInfo-payment-name'>
          {card.name}
        </Paragraph>
        <Paragraph mt={2} data-testid='paymentInfo-payment-card'>
          **** **** **** {card.last4}
        </Paragraph>
        <Paragraph mt={2} data-testid='paymentInfo-payment-valid-date'>
          Valid until {card.expMonth}/{card.expYear}
        </Paragraph>
      </Box>
      {/* <Box sx={{ width: '50%' }}> */}
      {/*  <Heading level={2} size='medium'> */}
      {/*    <Trans>Billing Address</Trans> */}
      {/*  </Heading> */}
      {/*  <AddressCard */}
      {/*    address={{ */}
      {/*      name: billingAddress.name, */}
      {/*      address1: billingAddress.line1, */}
      {/*      address2: billingAddress.line2, */}
      {/*      city: billingAddress.city, */}
      {/*      country: billingAddress.country, */}
      {/*      zip: billingAddress.postalCode, */}
      {/*      province: billingAddress.state, */}
      {/*    }} */}
      {/*    width='100%' */}
      {/*    singleCard */}
      {/*    size='default' */}
      {/*    isPreview */}
      {/*  /> */}
      {/* </Box> */}
    </Box>
  );
});
